import React, { Component } from 'react';
import { LOGIN, ORDERS } from '../../routes';
import { Link, withRouter } from 'react-router-dom';
import { sendForgotPasswordEmail } from '../../services/auth';
import { session } from '../../services/session';

class ForgotPasswordPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: ''
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillMount() {
    if (session.has('uid')) {
      this.redirectToOrders();
    }
  }

  redirectToOrders() {
    this.props.history.push(ORDERS);
  }

  handleChange(event) {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  }

  handleSubmit(event) {
    event.preventDefault();
    sendForgotPasswordEmail(this.state.email)
      .then(() =>
        window.alert(
          'Success. Please check your email for password reset instructions.'
        )
      )
      .catch(message => window.alert(message));
  }

  render() {
    return (
      <div className="card">
        <h1 className="card-header h5">Forgot Your Password?</h1>
        <div className="card-body">
          <form onSubmit={this.handleSubmit}>
            <div className="form-group">
              <label htmlFor="email">Email:</label>
              <input
                type="email"
                id="email"
                name="email"
                className="form-control"
                value={this.state.email}
                onChange={this.handleChange}
                required
              />
            </div>
            <button type="submit" className="btn btn-primary mr-4">
              Send Reset Email
            </button>
            <Link to={LOGIN}>Back to Login</Link>
          </form>
        </div>
      </div>
    );
  }
}

export default withRouter(ForgotPasswordPage);



// WEBPACK FOOTER //
// ./src/components/auth/ForgotPasswordPage.js